import { render, staticRenderFns } from "./NextDates.vue?vue&type=template&id=ddb5a476&scoped=true"
import script from "./NextDates.vue?vue&type=script&lang=js"
export * from "./NextDates.vue?vue&type=script&lang=js"
import style0 from "./NextDates.vue?vue&type=style&index=0&id=ddb5a476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb5a476",
  null
  
)

export default component.exports